// ICEGATERegistration.jsx
import React from "react";

export default function ICEGATERegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ICEGATE Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ICEGATE Registration for Importers &amp; Exporters
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists exporters and importers with ICEGATE
            Registration for electronic customs filing, enabling online
            submission of Shipping Bills, Bills of Entry, duty payment, and
            document uploads through the customs e‑gateway.[web:244][web:245][web:247]
          </p>
          <p className="text-gray-700">
            The service focuses on linking your IEC, PAN, and authorised
            signatory details correctly on the portal so that trade operations
            can run smoothly with digital customs processes and reduced
            paperwork.[web:244][web:246][web:247]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/4484078/pexels-photo-4484078.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Container port and digital trade interface symbolising customs e-filing"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ICEGATE Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps consolidate trade identity and KYC
              details so that ICEGATE registration requests are complete and
              consistent with DGFT and customs records.[web:244][web:246][web:247]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  IEC certificate issued by DGFT, with details matching the
                  current business name and address.[web:244][web:246][web:247]
                </li>
                <li>
                  PAN card details of the IEC holder and basic tax identifiers
                  such as GSTIN, wherever required for verification or
                  auto‑registration.[web:244][web:245][web:247]
                </li>
                <li>
                  Authorised signatory details, including name, mobile number,
                  email ID (as per DGFT/IEC records), and KYC document such as
                  Aadhaar, PAN, or voter ID.[web:244][web:246]
                </li>
                <li>
                  Class‑3 Digital Signature Certificate (DSC) and authority
                  letter, where the registration workflow still requires
                  DSC‑based validation instead of simplified OTP auto‑registration.[web:244][web:246][web:248]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm’s support combines trade compliance know‑how with
              familiarity around customs e‑services, helping importers and
              exporters move quickly to a fully electronic workflow.[web:244][web:246][web:247]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trade Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on how ICEGATE integrates with IEC, DGFT, and
                  customs processes, including use of services like e‑Sanchit,
                  document tracking, and status checks.[web:245][web:246][web:247]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Online Registration
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in entering trade and KYC details correctly,
                  mapping DSC or OTP‑based flows, and minimizing registration
                  errors or mismatches with DGFT data.[web:244][web:245][web:246]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  Continued support from initial ICEGATE signup through use of
                  key services like online filing, duty payment, and export
                  document tracking.[web:245][web:246][web:247]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover-bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
